<template>


  <b-card
    title="Historique états quotidiens"
    class="shadow-sm h-100"
  >

    <b122-table
      ref="B122TableDailyStatus"
      identifier="B122TableDailyStatus"
      :init-b122-table-url="'/dailyStatus/initB122Table?restrictbylong-hospitalizationId='+hospitalization.id"
      :get-b122-table-results-url="'/dailyStatus/getB122TableResults?restrictbylong-hospitalizationId='+hospitalization.id"
      :fields="tableFields"
      initial-sort-by="forDate"
      :initial-sort-desc="true"
      @setTotalCount="setTotalCount"
      @clickOnShowBtn="clickOnShowBtn"
      @clickOnEditBtn="clickOnEditBtn"
      @clickOnDeleteBtn="clickOnDeleteBtn"
    >
      <template #cell(publicationDate)="data">
        <div class="bold-text">
          <check-icon v-if="data.value" style="color: var(--main-green)"></check-icon>
          <x-icon v-else class="main-red-color"></x-icon>
        </div>
      </template>

      <template #cell(transits)="data">
        <span v-if="data.value === '-' ">{{data.value}}</span>
        <span v-else style="white-space: pre">{{data.value}}</span>
      </template>

      <template #cell(foods)="data">
        <span>Alimentation assistée : {{data.item.tubeFeeding ? 'Oui' : 'Non'}}<br></span>
        <span v-if="data.value === '-' && data.item.tubeFeeding === false">{{data.value}}</span>
        <span v-else-if="data.value !== '-'" style="white-space: pre">{{data.value}}</span>
      </template>
    </b122-table>

    <!-- Modal Delete -->
    <daily-status-delete-modal
      :selected="ui.selected"
      @didDelete="didDelete()"
    ></daily-status-delete-modal>

  </b-card>

</template>

<script>

import B122Table from "../../components/b122/B122Table";
import DailyStatusDeleteModal from "./DailyStatusDeleteModal";

export default {

  name: 'DailyStatusIndex',

  components: {
    B122Table,
    DailyStatusDeleteModal
  },

  props: {
    hospitalization: {
      type: Object,
      required: true
    }
  },

  emits: ['didDeleteDailyStatus', 'clickOnShowBtn'],

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Date",
          key: "forDate",
          sortable: true,
          formatter: function (value, key, item) {
            var date = new Date(value)
            return date.toLocaleString('fr-FR',  { year: 'numeric', month: '2-digit', day: '2-digit' })
          }
        },
        {
          label: "Période",
          key: "isMorning",
          sortable: false,
          formatter: function (value, key, item) {
            return value ? 'Matin' : 'Soir'
          }
        },
        {
          label: "Publié ?",
          key: "publicationDate",
          sortable: true,
          formatter: function (value, key, item) {
            if (value) {
              let date = new Date(value)
              return date.toLocaleString('fr-FR',  { year: 'numeric', month: '2-digit', day: '2-digit' })
            }
            return null
          }
        },
        {
          label: "État de santé",
          key: "healthState.name",
          sortable: true
        },
        {
          label: "Transit",
          key: "transits",
          sortable: false,
          formatter: function (value, key, item) {
            let arrayTransit = []
            if(value != null) value.forEach(transit => transit !== undefined ? arrayTransit.push(transit) : null)
            if(arrayTransit.length > 0){
              return arrayTransit.join('\r\n')
            }else{
              return "-"
            }
          }
        },
        {
          label: "Alimentation",
          key: "foods",
          sortable: false,
          formatter: function (value, key, item) {
            let arrayFoods = []
            if( value != null) value.forEach(food => food !== undefined && food != null && food.quantity > 0 ? arrayFoods.push(`${food.name} ${food.quantity}%`) : null)
            if(arrayFoods.length > 0){
              return arrayFoods.join('\r\n')
            }else{
              return "-"
            }
          }
        },
        {
          label: "",
          key: "actions"
        }
      ],

      ui: {
        selected: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnShowBtn(row) {
      this.$emit("clickOnShowBtn", row.item)
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'DailyStatusEdit',
        params: {
          dailyStatusId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selected = row.item
      this.$bvModal.show('daily-status-delete-modal')
    },

    didDelete() {
      this.ui.selected = null;
      this.$refs.B122TableDailyStatus.refreshTable()
      this.$emit('didDeleteDailyStatus')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/DailyStatusIndex.vue